import useStore from "config/store";

// Returns the check as a function, for lists that cannot call a hook per item.
export function useHasPermission() {
  const userData = useStore(state => state.userData);
  const userPermissions = userData?.permissions || [];

  return (requiredPermissions: string[]) =>
    requiredPermissions.every(perm => userPermissions.includes(perm)) || userData?.isSuperuser;
}

export default function useCheckPermissions(requiredPermissions: string[]) {
  return useHasPermission()(requiredPermissions);
}
